import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSnackbarMessage } from '../../model/configuratorSlice';
import { TranslationUtility } from '../../utilities/TranslationUtility';
import { FeedbackMessages } from '../../model/constants';

const Snackbar = () => {
    const snackbarMessage = useSelector(state => state.configurator.snackbarMessage);
    const dispatch = useDispatch();

    const hideSnackbar = () => {
        dispatch(setSnackbarMessage(''));
    };

    useEffect(() => {
        if (snackbarMessage !== '') {
            setTimeout(hideSnackbar, 10000);
        }
    }, [snackbarMessage]);

    const getTranslatedSnackbarMessage = (message) => {
        switch (message) {
            case FeedbackMessages.DisabledInDemo:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-disabled-in-demo', 'Función deshabilitada en la demo');
            case FeedbackMessages.LoginSuccess:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-login-success', 'Sesión iniciada con éxito');
            case FeedbackMessages.LoginError:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-login-error', 'Error al iniciar sesión');
            case FeedbackMessages.LogoutSuccess:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-logout-success', 'Sesión cerrada con éxito');
            case FeedbackMessages.LogoutError:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-logout-error', 'Error al cerrar sesión');
            case FeedbackMessages.RequestBudgetSuccess:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-request-budget-success', 'Configuración formalizada con éxito.');
            case FeedbackMessages.RequestBudgetError:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-request-budget-error', 'Se ha producido un error al formalizar.');
            case FeedbackMessages.CodeCopiedToClipboard:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-code-copied-to-clipboard', 'Código copiado en el portapapeles');
            case FeedbackMessages.ConfigurationCodeLoadedSuccesfully:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-configuration-code-loaded-succesfully', 'Se ha cargardo con éxito la configuración');
            case FeedbackMessages.ConfigurationCodeNotFound:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-configuration-code-not-found', 'El código de configuración no existe');
            case FeedbackMessages.RequestBudgetEndDate:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-request-budget-end-date', 'El proceso de formalización finaliza el: ');
            case FeedbackMessages.RequestBudgetEnded:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-request-budget-ended', 'El proceso de formalización ha finalizado');
            case FeedbackMessages.SavingConfiguration:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-saving-configuration', 'Guardando configuración...');
            case FeedbackMessages.Loading:
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-loading', 'Cargando...');
            case FeedbackMessages.ErrorSavingConfiguration:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-error-saving-configuration', 'Error guardando configuración');
            case FeedbackMessages.GeneratingPdf:
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-generating-pdf', 'Generando PDF...');
            case FeedbackMessages.RequestingBudget:
                // eslint-disable-next-line max-len
                return TranslationUtility.GetFormattedMessageForUI('ui-feedback-requesting-budget', 'Formalizando Configuración...');
            default:
                return message;
        }
    };


    return snackbarMessage !== '' ? (
      <div className="snackbar-container">
        <div className="text">
          {getTranslatedSnackbarMessage(snackbarMessage)}
        </div>
      </div>
    ) : null;
};

export default Snackbar;
